/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Type_SecondaryInputs */

const en_task_catalog_type_secondary = /** @type {(inputs: Task_Catalog_Type_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can stay open alongside other activities`)
};

const pt_br2_task_catalog_type_secondary = /** @type {(inputs: Task_Catalog_Type_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode ficar aberta junto com outras atividades`)
};

/**
* | output |
* | --- |
* | "Can stay open alongside other activities" |
*
* @param {Task_Catalog_Type_SecondaryInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_type_secondary = /** @type {((inputs?: Task_Catalog_Type_SecondaryInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Type_SecondaryInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_type_secondary(inputs)
	return pt_br2_task_catalog_type_secondary(inputs)
});